import React from 'react';
import { Heading } from '../../components/guide/Heading';
import HeroBanner from "../../components/guide/HeroBanner";
import BannerImg from "../../assets/images/banner/guide_banner_5.png";
import CtaBanner from "../../components/guide/CtaBanner";
import BuildingImg1 from "../../assets/images/building/building_1.png";
import BuildingImg2 from "../../assets/images/building/building_2.png";
import BuildingImg3 from "../../assets/images/building/building_3.png";
import BuildingImg4 from "../../assets/images/building/building_4.png";
import BuildingImg5 from "../../assets/images/building/building_5.png";
import BuildingImg6 from "../../assets/images/building/building_6.png";
import BuildingImg7 from "../../assets/images/building/building_7.png";
import HeaderPath from "../../components/common/HeaderPath";

const PropertyGuidePage: React.FC = () => (
    <section className="w-full bg-white">
        <div className="mx-auto w-full max-w-[1072px] px-0 sm:px-6 lg:px-0">
            <HeaderPath path={'> 물건별 광고 가이드'}/>
            <HeroBanner image={BannerImg} message="미분양 브랜딩부터, 완판 성공까지!"/>
            <Heading className="hidden lg:block lg:mt-[93px] lg:mb-[96px]" as="h1" size="h1">
                물건별 광고 가이드
            </Heading>
            <div className="mt-0 flex flex-col gap-12 sm:gap-16 lg:mt-0 lg:gap-[93px]">
                <Heading as="p" size="subtitle" className="text-black font-[400] leading-relaxed">
                    분양의신은 모든 현장을 같은 방식으로 광고하지 않습니다.<br/>
                    물건의 성격과 현장 상황에 맞춰 KPI부터 소재 전략까지 달리 설계하며, ‘현장이
                    원하는 성과’를 끌어내는 광고만 집행합니다.
                </Heading>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">1. 아파트 광고 [지역주택조합]</h5>
                    <p className="my-5 text-base font-[400] leading-relaxed text-slate-800 sm:my-[20px] sm:text-[18px]">
                        조합 아파트 광고는 신뢰성과 안정성이 핵심이기 때문에 직접적인 조합 문구보다 가격 경쟁력과 주거 장점을 전면에<br
                        className={'block md:hidden'}/>
                        배치합니다.<br/>
                        조합 관련 정보는 상세 설명이나 하단 안내로 자연스럽게 전달하여, 고객의 불안 요인을 줄이고 긍정적인 인식을 강화합니다.
                    </p>
                    <img className="w-full " src={BuildingImg1} alt="지역주택조합 아파트 광고 예시" />
                </div>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">2. 아파트 광고 [일반분양/미분양]</h5>
                    <p className="my-5 text-base font-[400] leading-relaxed text-slate-800 sm:my-[20px] sm:text-[18px]">
                        일반분양·미분양 아파트 광고는 단기 전환보다 브랜드 신뢰와 긍정적 이미지 형성이 우선입니다. 조감도, 브랜드
                        로고, 설계 특장점, 입지적 장점 등 다각적 요소를 종합적으로 강조하여 "장기적으로 이 아파트를 이 가격에 구매해야 하는 이유"를 설득력 있게 전달하는 방식이 효과적입니다.
                    </p>
                    <img className="w-full " src={BuildingImg2} alt="일반분양·미분양 아파트 광고 예시" />
                </div>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">3. 오피스텔 광고</h5>
                    <p className="my-5 text-base font-[400] leading-relaxed text-slate-800 sm:my-[20px] sm:text-[18px]">
                        오피스텔은 수요 목적(실거주 vs 투자)에 따라 메시지를 차별화합니다. 실거주형은 아파텔·랜드마크 키워드와
                        함께 세련된 인테리어 컷을 활용해 주거 가능성을 강조하는 반면, 투자형은 임대수익률, 역세권·학세권 등 수익 구조와 입지 지도를 활용한 가치를 강조합니다.
                    </p>
                    <img className="w-full " src={BuildingImg3} alt="오피스텔 광고 예시" />
                </div>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">4. 토지 광고</h5>
                    <p className="my-5 text-base font-[400] leading-relaxed text-slate-800 sm:my-[20px] sm:text-[18px]">
                        토지 광고는 실물이 없기 때문에 고퀄리티 3D 이미지와 평단가 중심의 메시지가 필수입니다. 또한 교통망과
                        개발계획 등 입지 가치를 명확히 드러내야 합니다.
                    </p>
                    <img className="w-full " src={BuildingImg4} alt="토지 광고 예시" />
                </div>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">5. 타운하우스 광고</h5>
                    <p className="my-5 text-base font-[400] leading-relaxed text-slate-800 sm:my-[20px] sm:text-[18px]">
                        타운하우스는 고가 주거상품이므로 고급스러움과 희소성을 중심으로 설계합니다. 프리미엄 인테리어·독립 주거
                        형태·상위 N%만이 누릴 수 있는
                        라이프스타일을 강조하는 것이 핵심입니다.
                    </p>
                    <img className="w-full " src={BuildingImg5} alt="타운하우스 광고 예시" />
                </div>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">6. 상가 광고</h5>
                    <p className="my-5 text-base font-[400] leading-relaxed text-slate-800 sm:my-[20px] sm:text-[18px]">
                        상가 광고는 수익성·안정성·입점 브랜드 등의 정보를 직관적으로 보여주는 것이 중요합니다. 유동인구, 보장
                        수익률, 입점 현황 등을 시각적으로 전달해
                        투자 설득력을 높입니다.
                    </p>
                    <img className="w-full " src={BuildingImg6} alt="상가 광고 예시" />
                </div>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">7. 오피스 광고</h5>
                    <p className="block md:hidden my-5 text-base font-[400] leading-relaxed text-slate-800 sm:my-[20px] sm:text-[18px]">
                        · 디스플레이 광고 (지메일MO·기사MO·구글 MO)<br/>
                        · 검색광고 (구글 검색지면 PC, 유튜브 검색 PC)<br/>
                        · 영상광고 (유튜브 인스트림, 범퍼애드, 인피드MO)
                    </p>
                    <p className="hidden md:block my-5 text-base font-[400] leading-relaxed text-slate-800 sm:my-[20px] sm:text-[18px]">
                            오피스 광고는 입지와 교통 접근성을 중심으로, 평단가·대출 규제·대형평수 가능성·실투자금 등 정보성 데이터를 강조합니다.<br/>
                            동시에 내부 이미지를 통해 “내가 직접 일하고 싶은 공간”이라는 감성적 매력을 주는 비주얼도 중요합니다.
                        </p>
                        <img className="w-full " src={BuildingImg7} alt="오피스 광고 예시"/>
                </div>


                <CtaBanner
                    message="물건에 따라 전략은 달라져야 합니다."
                    buttonText="광고문의 바로가기 →"
                    href="https://분양의신.net/contact"
                />
            </div>
        </div>
    </section>
);

export default PropertyGuidePage;
